import { render, staticRenderFns } from "./ktmjindex_A.vue?vue&type=template&id=a3b5267e&scoped=true&"
import script from "./ktmjindex_A.vue?vue&type=script&lang=js&"
export * from "./ktmjindex_A.vue?vue&type=script&lang=js&"
import style0 from "./ktmjindex_A.vue?vue&type=style&index=0&id=a3b5267e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3b5267e",
  null
  
)

export default component.exports